// T-282/collettiva: rotazione del menù determinata dalla DATA (non inserita a
// mano). Bluecoop ruota su 4 settimane: 2ªA → 2ªB → 1ªA → 1ªB, ancorate al
// lunedì della settimana del 18/05/2026 (= 2ªA, confermato da Pierpaolo:
// 18/05=2A, 25/05=2B, 01/06=1A, 08/06=1B, e così via). Il menù del giorno si
// calcola: data → slot rotazione (settimana 1|2, variante A|B) + giorno feriale.

export interface MenuSlot {
  week: 1 | 2;
  variant: 'A' | 'B';
}
export interface MenuSlotForDay extends MenuSlot {
  weekday: number; // 1 = lunedì … 7 = domenica
}

const DAY_MS = 24 * 60 * 60 * 1000;
// Ordine del ciclo a partire dall'ancora (lunedì del 18/05/2026).
const CYCLE: MenuSlot[] = [
  { week: 2, variant: 'A' },
  { week: 2, variant: 'B' },
  { week: 1, variant: 'A' },
  { week: 1, variant: 'B' },
];

// UTC midnight del giorno passato (accetta 'YYYY-MM-DD' o Date).
function utcMidnight(d: string | Date): number {
  if (typeof d === 'string') {
    const [y, m, day] = d.slice(0, 10).split('-').map(Number);
    return Date.UTC(y, (m ?? 1) - 1, day ?? 1);
  }
  return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
}

// Lunedì (UTC) della settimana che contiene la data.
function mondayUtc(d: string | Date): number {
  const t = utcMidnight(d);
  const dow = new Date(t).getUTCDay(); // 0 = domenica … 6 = sabato
  const backToMonday = (dow + 6) % 7; // lun→0, dom→6
  return t - backToMonday * DAY_MS;
}

const ANCHOR_MONDAY = mondayUtc('2026-05-18');

// 1 = lunedì … 7 = domenica
export function isoWeekday(d: string | Date): number {
  const dow = new Date(utcMidnight(d)).getUTCDay();
  return ((dow + 6) % 7) + 1;
}

export function menuSlotForDate(d: string | Date): MenuSlotForDay {
  const weeks = Math.floor((mondayUtc(d) - ANCHOR_MONDAY) / (7 * DAY_MS));
  const idx = ((weeks % 4) + 4) % 4;
  const slot = CYCLE[idx]!;
  return { ...slot, weekday: isoWeekday(d) };
}

export function menuSlotLabel(s: MenuSlot): string {
  return `${s.week}ª settimana · menù ${s.variant}`;
}

export const WEEKDAY_LABELS = ['Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato', 'Domenica'] as const;
